import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slice/userSlice";
import savedPropertyReducer from "./slice/savedPropertySlice";
import incompPropertyReducer from "./slice/incompleteProp";
import messageReducer from "./slice/messageSlice";
import authModalReducer from "./slice/authModalSlice";
import navigatorReducer from "./slice/navigatorSlice";
import walletReducer from "./slice/walletSlice";
import colorReducer from "./slice/colorSlice";
import { combineReducers } from "redux";
import thunk from "redux-thunk";

const reducers = combineReducers({
  user: userReducer,
  savedProperty: savedPropertyReducer,
  incompProperty: incompPropertyReducer,
  message: messageReducer,
  authModal: authModalReducer,
  navigator: navigatorReducer,
  wallet: walletReducer,
  color: colorReducer,
});

const store = configureStore({
  reducer: reducers,
  middleware: [thunk],
});

export default store;
